import Thumbor from "thumbor";

const thumbor = () => new Thumbor(null, process.env.REACT_APP_THUMBOR_URL);

export default thumbor;
